module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VG0002-71c272a9dbfffc3e2439877f5ae76664.png";